import * as debug from 'debug';
import * as _ from 'lodash';
import { App, ModalController } from 'ionic-angular';
import { Component } from '@angular/core';
import { UserProvider } from '../../providers/user/user';
import { ToolsProvider } from '../../providers/tools/tools';
import { ConfigProvider } from '../../providers/config/config';
import { LiveChatProvider } from '../../providers/live-chat/live-chat';
import { Keyboard } from '@capacitor/keyboard';
import { Capacitor } from '@capacitor/core';
@Component({
  selector: 'lc-prompt-header',
  templateUrl: 'lc-prompt-header.html',
})
export class LcPromptHeaderComponent {
  log = debug('app:LcPromptHeaderComponent');

  time = 30;

  liveStatus = {
    countDown: 'Kickof in ' + this.time,
    eventStatus: '🏈' + '1 - 0' + '👩‍⚖️',
    live: 'Live Now',
  };

  newMessage = '';
  can_send = false;
  roomToShow: any[] = [];
  eventRooms: any[] = [];
  generalTimedRooms: any[] = [];
  generalRooms: any[] = [];
  lcGiveAwayConfig;

  showEventPrompt = true;

  subs = [];

  constructor(
    public user: UserProvider,
    public tools: ToolsProvider,
    public appCtrl: App,
    public modalCtrl: ModalController,
    public configs: ConfigProvider,
    public liveChat: LiveChatProvider
  ) {}

  // public navCtrl: NavController
  //TO do if user hit x on event

  ngOnInit() {
    // Wait for all promises to resolve
    //Check for Event Rooms first, if no event rooms, default to timed room if
    // if no timed rooms default to general rooms
    this.setRoomToShow();
    this.subs.push(
      this.tools.on('refreshRoomPrompts', () => {
        this.setRoomToShow();
      })
    );

    this.lcGiveAwayConfig = this.configs.get(
      'sponsorship-live-chat-giveaway'
    );
  }

  organizeRooms(room) {
    if (!room.isClosed) {
      if (room.eventOpenTime) {
        this.eventRooms.push(room);
      } else if (!room.eventOpenTime && room.openTime) {
        this.generalTimedRooms.push(room);
      } else {
        this.generalRooms.push(room);
      }
    }
  }

  openSponsorshipUrl(room) {
    const url = _.get(room, 'sponsorship.url');
    if (url) {
      this.tools.openExternalUrl(url, 'external');
    }
  }

  setRoomToShow() {
    this.liveChat.getPublicRooms().then(publicChats => {
      const roomPromises = publicChats.map(room => this.organizeRooms(room));

      Promise.all(roomPromises).then(() => {
        if (_.size(this.eventRooms) > 0) {
          this.roomToShow = _.sample(this.eventRooms);
        } else if (
          _.size(this.eventRooms) === 0 &&
          _.size(this.generalTimedRooms) > 0
        ) {
          this.roomToShow = _.sample(this.generalTimedRooms);
        } else if (
          _.size(this.eventRooms) === 0 &&
          _.size(this.generalTimedRooms) === 0
        ) {
          this.roomToShow = _.sample(this.generalRooms);
        }
      });
    });
  }

  submitChatPrompt() {
    let messageObj = {
      message: this.newMessage,
      conversationId: _.get(this.roomToShow, '_id'),
      directMessage: _.get(this.roomToShow, 'directMessage'),
      removedUserIds: _.get(this.roomToShow, 'removedUserIds'),
    };

    this.liveChat.sendMessage(messageObj, _.get(this.roomToShow, 'socketId'));
    this.newMessage = '';
  }

  hideEventPrompt() {
    this.showEventPrompt = false;

    if (_.size(this.generalTimedRooms) > 0) {
      this.roomToShow = this.generalTimedRooms[0];
    } else {
      this.roomToShow = this.generalRooms[0];
    }
  }

  focusOnChat(room) {
    if (Capacitor.getPlatform() != 'web') {
      Keyboard.hide();
    }

    // this.tools.openExternalUrl(`/home/chat/${room._id}`, 'deep-link');

    this.tools.navTo('ChatPage', 1, {
      conversation: room,
      conversation_id: _.get(room, '_id'),
      showKeyBoard: true,
    });
    this.tools.emit('refreshRoomPrompts');
  }
}



// WEBPACK FOOTER //
// ./src/components/lc-prompt-header/lc-prompt-header.ts